import { get, internalDestroy, internalPost, internalPut } from '.';
import qs from 'qs';

export const getCategories = ({ filters }) => {
  return get(`/categories?${qs.stringify(filters)}`);
};

export const getCategory = ({ categoryId, locale }) => {
  return get(`/categories/${categoryId}?locale=${locale}`);
};

export const createCategory = ({ payload, locale }) => {
  return internalPost(`/categories??locale=${locale}`, payload);
};

export const updateCategory = ({ categoryId, payload, locale }) => {
  return internalPut(`/categories/${categoryId}?locale=${locale}`, payload);
};

export const deleteCategory = ({ categoryId, payload }) => {
  return internalDestroy(`/categories/${categoryId}`, payload);
};
